// extracted by mini-css-extract-plugin
export default {"file":"styles_file__X+qiV","filename":"styles_filename__HBr+U","link":"styles_link__mrAXD","fileDelete":"styles_fileDelete__SzWdw"};